import { gql } from '@apollo/client';

export const REJECT_EXTRA_ACTIVITY_ASSIGNMENT = gql`
	mutation rejectExtraActivityAssignment($workAssignmentKey: WorkAssignmentKey!) {
		rejectExtraActivityAssignment(workAssignmentKey: $workAssignmentKey) {
			__typename
			... on WorkAssignmentExtraActivitySuccessResponse {
				workAssignmentSequence {
					isMultiRide
					sequenceGroupId
					rideId
					crewMember {
						id
						fullName
					}
					fromStation {
						id
						name
						code
					}
					toStation {
						id
						name
						code
					}
					fromTimestamp
					toTimestamp
					activityType
					status
					workAssignments {
						crewMember {
							id
							fullName
						}
						status
						version
						id
						fromStation {
							id
							name
						}
						toStation {
							id
							name
						}
					}
					run {
						name
						id
					}
					job {
						id
						code
						runId
					}
					extraActivities {
						fromTimestamp
						toTimestamp
						id
						version
						status
						fromStation {
							id
							code
							timezone
						}
						toStation {
							id
							code
							timezone
						}
						activityType
					}
				}
			}
			... on WorkAssignmentExtraActivityErrorResponse {
				errors
			}
		}
	}
`;
